import router from '../../router';
import dishGroupApi from '../../api/dish-group-api';


const RESOURCE_NAME = '/app/dish_group';
const RESOURCE_NAME_PUBLIC = '/app/public/sales';

const dishGroups = {
    items: [],
    item: {},
    popupNewDishGroup: false,
    popupEditDishGroup: false,
    popupSeeDishGroup: false
};

const mutations = {
    setItemsDishGroup(state, payload) {
        state.items = payload.data;
    },
    setItemDishGroup(state, payload) {

        state.item = payload;

    },
    setpopupNewDishGroup(state, payload) {
        state.popupNewDishGroup = payload;
    },
    setpopupEditDishGroup(state, payload) {
        state.popupEditDishGroup = payload;
    },
    setpopupSeeDishGroup(state, payload) {
        state.popupSeeDishGroup = payload;
    },
};


const actions = {
    createDishGroup({ commit, dispatch }, { dishGroup, language }) {
        commit('loading', true);
        dishGroupApi.create(dishGroup, language).then(
            (response) => {
                dispatch('refreshDishGroup', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'fidelization.DishGroupCreated' });
                commit('loading', false);
                commit('setpopupNewDishGroup', false);

                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'fidelization.DishGroupNotCreated', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    assignDishGroup({ commit, dispatch }, { dishGroup, language }) {
        commit('loading', true);
        dishGroupApi.assignToDishGroup(dishGroup, language).then(
            (response) => {
                commit('notifications', { title: 'fidelization.DishGroupAssigned' });
                commit('loading', false);

                router.push({ name: 'dish-groups' });
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'fidelization.DishGroupNotAssigned', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    editDishGroup({ commit, dispatch }, { dishGroup, id, language }) {
        commit('loading', true);

        dishGroupApi.edit(dishGroup, id, language).then(
            (response) => {
                dispatch('refreshDishGroup', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'fidelization.DishGroupModified' });
                commit('loading', false);
                commit('setpopupEditDishGroup', false);

                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'fidelization.DishGroupNotModified', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },

    async refreshDishGroup(context, { restaurant_id, language }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }

        const res = await dishGroupApi.getAllByRestaurant(restaurant_id, language);

        context.commit('setItemsDishGroup', res);
    },



    async getDishGroup(context, { id, language }) {
        context.commit('loading', true);
        context.commit('setItemDishGroup', {});
        const res = await dishGroupApi.getOne(id, language);

        context.commit('setItemDishGroup', res.data[0]);
        context.commit('loading', false);

    },


    async getDishGroups(context, { restaurant_id, language }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }

        const res = await dishGroupApi.getAllByRestaurant(restaurant_id, language);

        context.commit('setItemsDishGroup', res);
    },

    deleteDishGroup({ commit, dispatch }, id) {
        commit('loading', true);
        dishGroupApi.delete(id).then(
            response => {
                dispatch('refreshDishGroup', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'fidelization.DishGroupDeleted' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            error => {
                commit('notifications', { title: 'fidelization.DishGroupNotDeleted', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
};

const getters = {
    getDishGroups: state => state.items,
    getDishGroup: state => state.item,
    getpopupNewDishGroup: state => state.popupNewDishGroup,
    getpopupEditDishGroup: state => state.popupEditDishGroup,
    getpopupSeeDishGroup: state => state.popupSeeDishGroup
};

export default {
    state: dishGroups,
    mutations,
    actions,
    getters,
};